<template>
  <div id="edicaoDadosHomologacaoLicitacao">
    <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(salvarDadosAdjHml)" class="">
        <b-row>
          <b-col cols="6">
            <h5 class="text-left">Dados de homologação</h5>
          </b-col>
          <b-col cols="6">
            <b-button type="submit" size="sm" class="float-right">
              <font-awesome-icon icon="save" />
              Salvar
            </b-button>
          </b-col>
        </b-row>
        <b-overlay :show="isReloading" rounded="sm">
          <b-row class="align-items-stretch h7rem">
            <b-col cols="12" sm="6" md="3">
              <default-form-validation-provider
                rules=""
                label="Data de Adjudicação"
                v-slot="defState"
              >
                <b-form-datepicker
                  v-model="licitacaoHml.DtAdjudicacao"
                  :state="defState.state"
                  v-bind="datePickerProps"
                >
                </b-form-datepicker>
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6" md="3">
              <default-form-validation-provider
                rules=""
                label="Homologação Parcial"
              >
                <b-form-radio-group
                  v-model="licitacaoHml.FlHomologParcial"
                  :options="hmlParcialOptions"
                  size="sm"
                  @change="trocouHmlParcial()"
                ></b-form-radio-group>
              </default-form-validation-provider>
            </b-col>
            <b-col
              v-if="licitacaoHml.FlHomologParcial === 'N'"
              cols="12"
              sm="6"
              md="3"
            >
              <default-form-validation-provider
                rules=""
                label="Data de Homologação"
                v-slot="defState"
              >
                <b-form-datepicker
                  v-model="licitacaoHml.DtHomologacao"
                  :state="defState.state"
                  v-bind="datePickerProps"
                >
                </b-form-datepicker>
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" sm="6" md="3">
              <default-form-validation-provider
                v-if="licitacaoHml.getTipoArquivo('ata') === 'salvo'"
                label="Ata de Abertura/Julgamento"
                rules=""
              >
                <span v-if="isArquivoAtaPreenchido"
                  >Nome: {{ licitacaoHml.ArquivoAta.NmArquivo }}</span
                >
                <div class="d-flex justify-content-center">
                  <btn-download
                    class="mr-2"
                    :fazerDownload="baixarAnexo"
                    :parametros="licitacaoHml.ArquivoAta"
                  />
                  <b-link class="text-dark" @click="removerArquivoAta()">
                    <font-awesome-icon icon="times" />
                    <div style="font-size: 12px">Remover</div>
                  </b-link>
                </div>
              </default-form-validation-provider>
              <default-form-validation-provider
                v-else
                label="Ata de Abertura/Julgamento"
                v-slot="defaultState"
                rules=""
              >
                <b-form-file
                  v-model="licitacaoHml.ArquivoAta"
                  placeholder="Nenhum arquivo selecionado"
                  accept="application/pdf"
                  :state="defaultState.state"
                ></b-form-file>
              </default-form-validation-provider>
            </b-col>
          </b-row>
        </b-overlay>
      </b-form>
    </validation-observer>
  </div>
</template>

<script lang="ts">
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import BtnDownload from '@/components/shared/btn-download.vue'
import { eventBus } from "@/main";
import ldiService from "@/services/licitacoes/ldiService";
import { store } from "@/store";
import { DatePickerDefaultProps } from "@/types/form-default-props";
import { ArquivoLicitacao } from "@/types/licitacoes/arquivo-licitacao";
import { LicitacaoHomologacao } from "@/types/licitacoes/ldi/licitacao-homologacao";
import { UtilsTS } from "@/utilsts";
import { ValidationObserver } from "vee-validate";
import { mixins } from "vue-class-component";
import { Component, Ref, Vue } from "vue-property-decorator";

const CompProps = Vue.extend({
  name: "EditarDadosHomologacaoLicitacao",
  components: { DefaultFormValidationProvider, ValidationObserver, BtnDownload },
  props: {
    lic: {
      type: Object,
      required: true,
    },
  },
});

@Component
export default class EditarDadosHomologacaoLicitacao extends mixins(
  UtilsTS,
  CompProps
) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  licitacaoHml: LicitacaoHomologacao = new LicitacaoHomologacao();
  hmlParcialOptions = [
    { text: "Sim", value: "S" },
    { text: "Não", value: "N" },
  ];
  datePickerProps = DatePickerDefaultProps;

  isReloading = false; // recarregando dados de hml, em virtude de uma alteração de vencedores

  get isArquivoAtaPreenchido() {
    return this.licitacaoHml?.ArquivoAta !== undefined
  }

  /** Validar e adicionar/alterar um participante a uma licitação existente */
  async salvarDadosAdjHml(): Promise<void> {
    try {
      store.blockScreen = true;
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver);
      } else {
        //salvar
        const retorno = await ldiService.salvarDadosHomologacao(
          this.licitacaoHml
        );
        this.$toast.success("Dados de homologação atualizados");
        this.$emit("atualizarLicitacao", null);
        if (this.licitacaoHml.FlHomologParcial === "N")
          eventBus.$emit(
            "atualizar-datas-homologacao",
            this.licitacaoHml.DtHomologacao
          );
        this.limparForm(retorno);
      }
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }
  async baixarAnexo(arquivo: ArquivoLicitacao) {
        const response = await ldiService.baixarAnexo(String(arquivo.IdArquivo))
        this.download(`ata-${this.licitacaoHml.NumeroAnoLicitacao}`, response.data)
    }
  removerArquivoAta() {
    this.licitacaoHml.ArquivoAta = undefined
    const nova = Object.assign(
        new LicitacaoHomologacao(),
        this.licitacaoHml
      );
      this.licitacaoHml = nova;
  }
  trocouHmlParcial() {
    try {
      store.blockScreen = true;
      if (this.licitacaoHml.FlHomologParcial === "S") {
        delete this.licitacaoHml.DtHomologacao;
      }
    } finally {
      store.blockScreen = false;
    }
  }
  async limparForm(licitacaoHmlAtualizada?: LicitacaoHomologacao) {
    if (licitacaoHmlAtualizada) {
      const novosDados = Object.assign(
        new LicitacaoHomologacao(),
        licitacaoHmlAtualizada
      );
      novosDados.tratarDadosAPI();
      this.licitacaoHml = novosDados;
    } else {
      this.licitacaoHml = new LicitacaoHomologacao();
      this.licitacaoHml.DtAdjudicacao = this.lic.DtAdjudicacao;
      this.licitacaoHml.DtHomologacao = this.lic.DtHomologacao;
      this.licitacaoHml.ArquivoAta = this.lic.ArquivoAta;
      this.licitacaoHml.NrLicitacao = this.lic.NrLicitacao;
      this.licitacaoHml.NrAnoLicitacao = this.lic.NrAnoLicitacao;
      this.licitacaoHml.NumeroAnoLicitacao = this.lic.NumeroAnoLicitacao;
      this.licitacaoHml.FlHomologParcial =
        this.lic.FlHomologParcial === "Não" ? "N" : "S";
    }
    this.licitacaoHml.IdLicitacao = this.lic.IdLicitacao; //garante que o ID sempre irá para o objeto sendo manipulado, uma vez que nas operações de save a api não retorna este ID
    this.validationobserver.reset();
  }

  /** Atualiza os dados de hml de uma licitação sempre que uma alteração de vencedores pode causar problema.
   * @since 20240125
   */
  async recarregar(): Promise<void> {
    this.isReloading = true;
    try {
      const response = await ldiService.buscarDadosHomologacao(
        this.lic.IdLicitacao
      );
      this.licitacaoHml = response;
      this.licitacaoHml.IdLicitacao = this.lic.IdLicitacao;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.isReloading = false;
    }
  }
  async mounted() {
    this.limparForm();
    eventBus.$on("atualizar-homologacao-licitacao", this.recarregar);
  }
  destroyed() {
    eventBus.$off("atualizar-homologacao-licitacao", this.recarregar);
  }
}
</script>

<style scoped>
div.h7rem {
  height: 7rem;
}

@media screen and (max-width: 768px) {
  div.h7rem {
    height: 11rem;
  }
}

@media screen and (max-width: 576px) {
  div.h7rem {
    height: 16rem;
  }
}
</style>